module.exports = __webpack_public_path__ + "static/littleWomen3-de0702a548c6071ae17d2ba983ab03bb.jpg";